export const signOut = () => {
	localStorage.clear();
	sessionStorage.clear();
	window.location.replace('/sign-in');
};
